/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { pd } from '@airasia-rn/ui';
import { StyleSheet } from 'react-native-unistyles';

export const styles = StyleSheet.create((pd) => ({
  container: {
    width: '100%',
    alignSelf: 'center',
    minHeight: 90,
    marginHorizontal: 'auto',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
  },
  loading: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    justifyContent: 'center',
    alignItems: 'center',
  },
  skeletonLoader: {
    width: '100%',
    height: 90,
    borderRadius: pd.sys.shape.corner.small.bottomEnd,
  },
}));
